// global get specific child
// example: this.getChild(idChild)
export default {
  computed: {
    activityTypes () {
      return this.$store.getters.groupActivityTypes
    }
  },
  methods: {
    getActivityType (id) {
      if (this.activityTypes) {
        var activityType = this.activityTypes.find(function (type) {
          return type.id === id
        })
        if (activityType) {
          return activityType
        }
      }
      return false
    },
    getActivityTypeIcons () {
      if (this.activityTypes) {
        return this.$lodash().uniqBy(this.activityTypes, function (activityType) {
          return activityType.icon_id
        })
      }
      return false
    },
    getActivityTypesByIdIcon (id) {
      if (this.activityTypes) {
        return this.$lodash().filter(this.activityTypes, function (activityType) {
          return activityType.icon_id === id
        })
      }
      return false
    }
  }
}
